import {t} from 'i18next'
import {ApprenticeModuleGrade} from '../model/apprenticeModuleGrade.model'


export const gradeValue = (value: string | undefined | null):string => {
	if (!value) {
		return '-'
	}
	if (value === 'passed') {
		return t<string>('grade_module.grade.value.passed')
	}
	if (value === 'failed') {
		return t<string>('grade_module.grade.value.failed')
	}
	return value
}

export const getTranslatedGrade = (g: ApprenticeModuleGrade): string => {
	const mGrade = g.module_grade?.grade_value
	return gradeValue(mGrade)
}
